import { defineMessages } from 'react-intl-next';

export const i18n: {
    onlyTitleMatch: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	onlyTitleMatch: {
		id: 'dynamic-cards-search-page.filters.names.titleMatchOnly',
		defaultMessage: 'Title match',
		description: 'Label for filtering by exact title match',
	},
});
